import RiotControl from 'riotcontrol'
import logger from '../logger'
import { pick } from 'lodash-es'
import extendedObservable from './base'
import api from '../api'


// //////////
// giftCards //
// //////////

export function GiftCards() {
  const orderResourceKey = 'savedGiftCards'
  extendedObservable(this, 'savedGiftCardsModel', { giftCards: [] })

  const successHandler = (json) => {
    logger('Success: Communicated with CA giftCards Service - ', 'info')()
    logger(json, 'info')()

    this.model.giftCards = json
    RiotControl.trigger('updateOrderResource', orderResourceKey, this.model)

    return this.model
  }

  const errorHandler = (xhr, status, errorThrown) => {
    logger(`Error: Failed to communicate with CA giftcard Service - ${errorThrown}`, 'error')()
    logger(`Status: ${status}`, 'error')()
    logger(xhr, 'error')()

    // update the order checksum
    const checksum = xhr.getResponseHeader('checksum')
    RiotControl.trigger('updateOrderChecksum', checksum)

    // hiding the global overlay screen after async stuff happens
    RiotControl.trigger('hideGlobalOverlay')
    return xhr
  }

  const addSuccessHandler = (json) => {
    logger('Success: Communicated with CA giftCards Service - ', 'info')()
    const parsed = JSON.parse(json)
    logger(parsed, 'info')()

    this.model.giftCards.push(parsed)
    RiotControl.trigger('updateOrderResource', orderResourceKey, this.model)

    return this.model
  }


  // register and unregister event listeners
  this.on('registerGiftCardsObserver', observer => this.registerObserver(observer))
  this.on('unregisterGiftCardsObserver', observer => this.unregisterObserver(observer))


  // POST /user/giftcard Adds a gift card with the given number/pin to the current user.
  // GET /user/giftcard/{cardId} Retrieves the current user's gift card with the given id.
  // DELETE /user/giftcard/{cardId} Deletes the current user's gift card with the given id.
  // GET /user/giftcards Retrieves the gift cards saved by the current user.


  // //////////////
  // Collection //
  // //////////////
  this.on('getGiftCards', (cb) => {
    logger('XHR :: Fetching saved gift cards from CA GC Service...', 'info')()
    logger('getGiftCards', 'debug')()
    api.giftCards.get()
      .then(successHandler)
      .then(this.notifyObservers)
      .then(cb)
      .fail(errorHandler)
      .fail((err) => {
        logger(err, 'debug')()
      })
  })

  // ////////////
  // Singular //
  // ////////////
  this.on('addGiftCard', (data, cb, errorCb) => {
    logger('addGiftCard', 'debug')()
    // check to see if there is already an order on the model,
    // if not hide the overlay and reject
    if (this.model === undefined) {
      RiotControl.trigger('hideGlobalOverlay')
      throw new Error('No giftCards Model')
    }

    const requestData = pick(data, 'pin', 'number')

    api.giftCard.post(requestData)
      .then(addSuccessHandler)
      .then(this.notifyObservers)
      .then(cb)
      .catch((err) => {
        logger(err, 'debug')()
        errorCb(err)
      })
  })

  this.on('getGiftCard', (id, cb) => {
    logger('getGiftCard', 'debug')()
    api.giftCard.get(id)
      .then(successHandler)
      .then(this.notifyObservers)
      .then(cb)
      .fail(errorHandler)
      .fail((err) => {
        logger(err, 'debug')()
      })
  })
}
